import { Notifications, SnackbarData } from '../models';
import * as actions from '../actions/notification.actions';

const INIT_STATE: Notifications = {
  notifications: []
};

/**
 * Reducer to maitain the notification state. We add the notification and the state of notification
 * is maintained
 *
 * @export
 * @param {any} [state=INIT_STATE]
 * @param {actions.All} action
 * @returns
 */
export function reducer(state = INIT_STATE, action: actions.All) {
  switch (action.type) {
    case actions.ADD_NOTIFICATION: {
      return { ...state, notifications: [...state.notifications, action.payload] };
    }
    default: {
      return state;
    }
  }
}

export const getNotifications: (Notifications) => Array<SnackbarData> = (state: Notifications) =>
  state.notifications;
